<template>
  <!-- 对话框 -->
  <el-dialog title="乘客钱包提现审核" :visible.sync="show" :before-close="closeDialog" style="width:60%; margin: 0 auto;">

    <!-- 基本信息表单 -->
    <div class="form-box">
      <el-form label-width="80px">

        <el-form-item label="审核判定:" label-width='120px'>
          <el-radio-group v-model="submit_data.status">



            <el-radio-button label="1">通过</el-radio-button>
            <el-radio-button label="2">驳回</el-radio-button>
            <el-radio-button label="5">余额支付</el-radio-button>



          </el-radio-group>
        </el-form-item>


        <el-form-item label="审核备注:" label-width='120px'>
          <el-input type="textarea" autosize v-model="submit_data.remarks"
            :placeholder="submit_rules.remarks.placeholder">
          </el-input>
        </el-form-item>




      </el-form>

      <div style="display: flex;justify-content: center">
        <el-button type="primary" @click="executeConsumerCashSubmit">保存</el-button>
        <el-button @click="closeDialog">关闭</el-button>
      </div>

    </div>

  </el-dialog>
</template>

<script>
  var _this;
  export default {
    props: {
      'isShow': Boolean,
      'data': ''
    },
    watch: {

      isShow(newData, oldData) {

        _this.show = true;

        _this.$post(
            '/consumer/getconsumerCashDetails', {
              consumer_cash_code: _this.data
            }
          )
          .then(res => {

            _this.submit_data.consumer_cash_code=res.data.consumer_cash_code;
            _this.submit_data.status=res.data.status.val;
            _this.submit_data.remarks=res.data.remarks;
            _this.status_arrway=res.data.status.select_array;

          }).catch((err) => {

          })


      },

    },
    data() {
      return {

        show: false,
        status_arrway:[],

        // 表单数据
        submit_data: {
          consumer_cash_code: '',
          status: '',
          remarks: ''
        },

        submit_rules: {
          consumer_cash_code: {
            placeholder: '唯一编码',
            rules: {
              required: true,
              message: '唯一编码错误',
              regulation: 'gt_str',
              rulesData: 0
            }
          },
          status: {
            placeholder: '审核状态',
            rules: {
              required: true,
              message: '未选择状态',
              regulation: 'egt_str',
              rulesData: 1
            }
          },
          remarks: {
            placeholder: '请输入审核备注',
            rules: {
              required: false,
              message: '审核备注未填写',
              regulation: 'egt_str',
              rulesData: 0
            }
          },

        },

      };
    },
    created() {
      _this = this;

    },
    methods: {


      // 关闭方法
      closeDialog() {

        _this.show = false;

        for (const key in _this.submit_data) {
          _this.submit_data[key] = '';
        }

      },

      // 提交按钮
      executeConsumerCashSubmit() {

        console.log(_this.submit_data);

        _this.$post(
            '/consumer/executeConsumerCashSubmit',
            _this.submit_data,
            _this.submit_rules
          )
          .then(res => {
            _this.$message.success(res.msg)
            // 向父组件通讯刷新表格内容
            _this.$emit('onSubmit');
            // 关闭对话框
            _this.closeDialog();

          }).catch((err) => {

          })
      }
    }
  };
</script>

<style scoped>
  .form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
  }
</style>
